// Single source of truth for Whop plan IDs (the Whop equivalent of Stripe
// price IDs in stripePriceIds.js). A Whop "plan" maps to a Stripe price_id.
//
// Whop sandbox vs live is controlled by the BACKEND (WHOP_USE_SANDBOX) and
// surfaced to the client via GET /payment/providers -> { whop_sandbox }. The
// resolver below takes that flag so the client always sends ids that match the
// backend's active Whop mode.
//
// Lifetime is a one-off (non-recurring) plan — `oneTime` is the single id, and
// the resolver falls back to it for any requested billing cycle.
export const WHOP_PLAN_IDS = {
  // Sandbox catalog (company biz_CmDFYffWMUK8AU "Sixth") has ONE plan per tier:
  // Pro/Pro+ are monthly, Ultra is yearly. Each plan id is mapped to BOTH cycles
  // so the checkout resolves whichever billing toggle is selected during testing.
  sandbox: {
    'Pro':      { monthly: 'plan_hbneVBt75YHbF', yearly: 'plan_hbneVBt75YHbF' },
    'Pro+':     { monthly: 'plan_epXMOprOC7iWC', yearly: 'plan_epXMOprOC7iWC' },
    'Ultra':    { monthly: 'plan_mG8EU6RZMibDh', yearly: 'plan_mG8EU6RZMibDh' },
    'Lifetime': { oneTime: 'plan_Mn4pb7KEpFIU7' }
  },
  // Production Whop plan ids — pulled from the live account via
  // scripts/fetch_whop_plans.py (WHOP_USE_SANDBOX=false). Keep these in sync with
  // the backend's WHOP_*_PLAN_ID env vars; both come from the same fetch output.
  live: {
    // Account "Mealio AI UGC" (biz_aoP1aTlOtVRe7p) — all four tiers configured.
    'Pro':      { monthly: 'plan_xTogGPNxvgN5w', yearly: 'plan_NtYtJYJyQ85io' },
    'Pro+':     { monthly: 'plan_y5EAbrbbFR2Dz', yearly: 'plan_bqWuIHIgngZPB' },
    'Ultra':    { monthly: 'plan_vtLyRFpz0wsbB', yearly: 'plan_B8Xlr2enhMSJM' },
    'Lifetime': { oneTime: 'plan_QQkkWSTwE2QRB' }
  }
};

// Resolve a Whop plan id by plan + billing cycle. `sandbox` (from the providers
// endpoint) picks the id set; for one-off plans (Lifetime) the `oneTime` id is
// returned regardless of the requested billing cycle.
export const getWhopPlanId = (planName, billing, sandbox = true) => {
  const mode = sandbox ? 'sandbox' : 'live';
  const plan = WHOP_PLAN_IDS[mode]?.[planName];
  if (!plan) return null;
  return plan[billing] || plan.oneTime || null;
};

export const WHOP_SUPPORTED_PLANS = ['Pro', 'Pro+', 'Ultra', 'Lifetime'];
